/**
 * Tamanho da foto no cartão da lista de Participantes: ela acompanha a altura do texto ao lado
 * (nome, conta, barras e linhas), para o cartão ficar proporcional. Sem barras nem linhas preenchidas
 * (as vazias não aparecem no cartão; preenchem-se pelo menu dele), o cartão fica compacto, com a foto
 * no tamanho mínimo.
 *
 * O original tem a foto fixa em 56 (`TBaseVerticalPresenceItemLayout::GetDefaultAvatarSize`); o
 * RPG Desk a deixa crescer com o cartão, a pedido do usuário (a foto parecia pequena ao lado das
 * barras e linhas).
 */

/** Cartão com barras ou linhas, mas com pouco texto. */
export const CARD_AVATAR_MIN = 72;
/** Cartão completo (4 barras e 4 linhas). */
export const CARD_AVATAR_MAX = 112;
/** Cartão sem barras nem linhas (só nome e conta): compacto, a foto no mínimo. */
export const CARD_AVATAR_ALONE = 72;
/** No painel estreito, a foto não passa desta fração da largura do cartão, para o texto caber. */
export const CARD_AVATAR_WIDTH_SHARE = 0.34;
/** O mesmo, no cartão sem barras nem linhas: o texto ao lado é curto. */
export const CARD_AVATAR_ALONE_WIDTH_SHARE = 0.38;

/**
 * Lado da foto (px), dada a altura do texto ao lado e a largura do cartão (0 = ainda sem medida).
 * `alone`: o cartão não mostra barras nem linhas.
 */
export function cardAvatarSize(textHeight: number, cardWidth: number, alone = false): number {
  if (alone) return cardWidth > 0 ? Math.min(CARD_AVATAR_ALONE, Math.round(cardWidth * CARD_AVATAR_ALONE_WIDTH_SHARE)) : CARD_AVATAR_ALONE;
  const byWidth = cardWidth > 0 ? Math.round(cardWidth * CARD_AVATAR_WIDTH_SHARE) : CARD_AVATAR_MAX;
  const ceiling = Math.min(CARD_AVATAR_MAX, byWidth);
  const floor = Math.min(CARD_AVATAR_MIN, ceiling);
  return Math.round(Math.max(floor, Math.min(ceiling, textHeight)));
}
